var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27934 7.27937C6.90689 7.65182 6.90689 8.25568 7.27934 8.62813L10.6512 12L7.27934 15.3719C6.90689 15.7444 6.90689 16.3482 7.27934 16.7207C7.65179 17.0931 8.25565 17.0931 8.6281 16.7207L12 13.3488L15.3719 16.7207C15.7444 17.0931 16.3482 17.0931 16.7207 16.7207C17.0931 16.3482 17.0931 15.7444 16.7207 15.3719L13.3488 12L16.7207 8.62813C17.0931 8.25568 17.0931 7.65182 16.7207 7.27937C16.3482 6.90692 15.7444 6.90692 15.3719 7.27937L12 10.6513L8.6281 7.27937C8.25565 6.90692 7.65179 6.90692 7.27934 7.27937Z",
    fill: "#333333"
  })));
}
export default SvgClose;